import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ColumnDef} from "@tanstack/react-table";
import {DataTable} from "@/lib/components/DataTable";
import {RequestsByMonthDTO} from "@/api/data-contracts";
import {ReportI18N} from "@/translations";

interface RequestsByMonthReportProps {
    data: RequestsByMonthDTO[];
}

interface RequestsByMonthRow extends RequestsByMonthDTO {
    id: number;
}

/**
 * Report table showing request counts per calendar month.
 */
const RequestsByMonthReport: React.FC<RequestsByMonthReportProps> = ({ data }) => {
    const { t } = useTranslation();

    const rows = useMemo<RequestsByMonthRow[]>(
        () => data.map((item, index) => ({ ...item, id: index })),
        [data]
    );

    const columns = useMemo<ColumnDef<RequestsByMonthRow>[]>(
        () => [
            {
                header: t(ReportI18N.page.column.year),
                accessorFn: (row) => row.year ?? "",
                id: "year"
            },
            {
                header: t(ReportI18N.page.column.month),
                accessorFn: (row) => row.month ?? "",
                id: "month"
            },
            {
                header: t(ReportI18N.page.column.count),
                accessorFn: (row) => row.requestCount ?? 0,
                id: "requestCount"
            }
        ],
        [t]
    );

    return <DataTable columns={columns} data={rows} noResultsValue="" striped maxHeight={940} />;
};

export default RequestsByMonthReport;
